import { domain } from "../auth/domain";

const authHeaders = () => {
  const token = localStorage.getItem("accessToken");
  if (!token) {
    throw new Error("Missing session. Please login again.");
  }
  return {
    Authorization: `JWT ${token}`,
    "Content-Type": "application/json",
  };
};

const handleJson = async (response) => {
  const text = await response.text();
  let data;
  try {
    data = text ? JSON.parse(text) : null;
  } catch {
    data = { detail: text };
  }

  if (!response.ok) {
    const message = data?.detail || data?.error || data?.description || "Request failed.";
    const err = new Error(message);
    err.data = data;
    err.status = response.status;
    throw err;
  }
  return data;
};

export const fetchBankReconciliation = async ({ reconcileDate, mode, limit, groupId } = {}) => {
  const params = new URLSearchParams();
  if (mode) params.set("mode", mode);
  if (limit !== undefined && limit !== null) params.set("limit", String(limit));
  if (groupId !== undefined && groupId !== null) params.set("group_id", String(groupId));
  const qs = params.toString() ? `?${params.toString()}` : "";
  const endpoint = reconcileDate
    ? `${domain}nmb/callback/reconciliation/${reconcileDate}/${qs}`
    : `${domain}nmb/callback/reconciliation/${qs}`;
  const resp = await fetch(endpoint, { method: "GET", headers: authHeaders() });
  return handleJson(resp);
};

export const manualReconcilePayment = async ({
  reference,
  receipt,
  amount,
  timestamp,
  channel,
  groupId,
} = {}) => {
  const resp = await fetch(`${domain}nmb/callback/manual-reconcile/`, {
    method: "POST",
    headers: authHeaders(),
    body: JSON.stringify({
      reference,
      receipt,
      amount,
      timestamp,
      channel,
      group_id: groupId,
    }),
  });
  return handleJson(resp);
};
